import { CONFIG } from "../config";
import * as helpers from "../../tools/helpers";

class BfvHeader {
  constructor(options = {}) {
    this.$root = options.element;
    [this.$header] = document.querySelectorAll(".js-bfv-header-and-navigation");
    this.sticky = helpers.getOffsetPosition(this.$root).top;
    this.last_known_scroll_position = helpers.getWindowScroll();
  }

  init() {
    this.bindClickEvents();

    window.addEventListener(CONFIG.events.RESIZE, () => {
      const currentWidth = helpers.getWindowSize().width;
      this.$header.style.width = `${this.$header.parentElement.offsetWidth}px`;

      if (this.currentWindowWidth !== currentWidth) {
        this.currentWindowWidth = currentWidth;
        this.closeHeader();
      }
    });

    window.addEventListener(CONFIG.events.VIEWPORT_SCROLL, (evt) => {
      if (helpers.isBodyScrollFreezed()) {
        return;
      }

      const $superbanner = document.querySelector(".bfv-superbanner");
      if ($superbanner) {
        this.sticky = $superbanner.offsetTop + $superbanner.offsetHeight;
      }

      this.stickyNav();
      this.showHeader(evt.detail.scroll);
      this.last_known_scroll_position = evt.detail.scroll;
    });
  }

  bindClickEvents() {
    const $menuButton = document.querySelector(".js-menu-button");

    $menuButton.addEventListener("click", (event) => {
      event.preventDefault();
      const menuToggleEvent = document.createEvent("event");
      menuToggleEvent.initEvent(
        CONFIG.events.BFV_OPEN_MOBILE_MENU,
        false,
        true,
      );
      window.dispatchEvent(menuToggleEvent);
      this.toggleHeader();
    });
  }

  toggleHeader() {
    this.$root.classList.toggle("bfv-header--open");
  }

  closeHeader() {
    this.$root.classList.remove("bfv-header--open");
  }

  stickyNav() {
    if (!this.$header) {
      return;
    }

    if (window.pageYOffset >= this.sticky) {
      this.$header.classList.add("bfv-nav-sticky");
    } else {
      this.$header.classList.remove("bfv-nav-sticky");
    }

    this.$header.style.width = `${this.$header.parentElement.offsetWidth}px`;
  }

  showHeader(scroll) {
    if (!this.$header) {
      return;
    }

    const scrollDiff = scroll.y - this.last_known_scroll_position.y;
    const documentHeightDiff =
      scroll.documentHeight - this.last_known_scroll_position.documentHeight;
    const startScrollHiding = this.sticky + this.$header.offsetHeight;

    if (
      scrollDiff > 0 &&
      documentHeightDiff === 0 &&
      this.$header.style.transform !== "translateY(-100%)" &&
      window.pageYOffset >= startScrollHiding
    ) {
      this.$header.style.transform = "translateY(-100%)";
    } else if (
      scrollDiff < 0 &&
      documentHeightDiff === 0 &&
      this.$header.style.transform !== "translateY(0)"
    ) {
      this.$header.style.transform = "translateY(0)";
    }
  }
}

export default BfvHeader;

